import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Work on React+D3js ES6 v2 begins in earnest",
  "description": "",
  "published": "2016-09-08T00:00:00.000Z",
  "redirect_from": ["/blog/work-on-reactd3js-es6-v2-begins-in-earnest/swizec/7010"],
  "categories": "d3js, Front End, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Here’s my crazy plan: I want to launch React+D3js ES6 v2 in the first week of October. This time as a free upgrade for current users.`}</p>
    <p>{`It’s a free upgrade because there was too much messiness when I launched the rewrite of my 2015 book of almost the same title. It wasn’t worth the effort and unhappiness that it causes.`}</p>
    <p>{`When my editor edits this post, he will shit his pants because I haven’t told him yet. But I hope it works out. ? `}<em parentName="p">{`[`}{`EDITOR’S NOTE: I was a bit surprised.]`}</em></p>
    <p>{`The plan so far looks like this:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`man up and fix all `}<a parentName="p" {...{
            "href": "https://github.com/Swizec/react-d3js-es6-ebook/issues"
          }}>{`these bugs`}</a>{` that @micahstubs reported`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`remove all the environment setup stuff and replace it with `}<a parentName="p" {...{
            "href": "https://facebook.github.io/react/blog/2016/07/22/create-apps-with-no-configuration.html"
          }}>{`create-react-app`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`improve the animations chapter`}</p>
        <ul parentName="li">
          <li parentName="ul">{`add more theoretical explanation`}</li>
          <li parentName="ul">{`break down concepts better`}</li>
          <li parentName="ul">{`add transitions approach`}</li>
          <li parentName="ul">{`discuss pre-made libraries and when to use them`}</li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`add a chapter on using canvas for rendering`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`talk about achieving high performance`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`add a chapter on visualizations in react-native`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`build a server-side visualization rendering example`}</p>
      </li>
    </ul>
    <p>{`And biggest of all → wrestle `}<a parentName="p" {...{
        "href": "https://www.livecoding.tv/swizec/"
      }}>{`36 hours of live coding video`}</a>{` into a coherent video course that’s worth proper money. Something on the level of those epic React+D3 workshops we did with Freddy`}<a parentName="p" {...{
        "href": "#fn1-20846",
        "title": "see footnote"
      }}>{`1`}</a>{`, but online and scalable and actually longer.`}</p>
    <p>{`I’m sure 36 hours of video is enough to build a killer course. All I need is some help with editing.`}</p>
    <p><strong parentName="p">{`Question:`}</strong>{` What did I miss? What did I not put in the content plan, but should?`}</p>
    <hr></hr>
    <ol>
      <li parentName="ol">{`3 workshops happened. The `}<a parentName="li" {...{
          "href": "https://swizec.com/blog/things-i-learned-my-first-workshop/swizec/6819"
        }}>{`1st was okay`}</a>{`, the 2nd was `}<a parentName="li" {...{
          "href": "http://www.meetup.com/Women-Who-Code-SF/events/232366807/"
        }}>{`pro bono for Women Who Code`}</a>{`, and the 3rd was sold out at `}<a parentName="li" {...{
          "href": "https://forwardjs.com/"
        }}>{`ForwardJS`}</a>{`. `}<a parentName="li" {...{
          "href": "#fnr1-20846",
          "title": "return to article"
        }}>{`↩︎`}</a></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      